export const INBOX_REFRESH_MS = 10_000;

// The caller handles load errors and checks the signal before applying results.
export function refreshWhileVisible(load: (signal: AbortSignal, automatic: boolean) => Promise<void>, initialDelay = 0) {
  let disposed = false;
  let pageHidden = false;
  let initial = true;
  let timer: number | undefined;
  let first: number | undefined;
  let active: AbortController | null = null;

  async function run() {
    if (disposed || pageHidden || document.hidden || active) return;
    const controller = new AbortController();
    active = controller;
    const automatic = !initial;
    initial = false;
    try { await load(controller.signal, automatic); }
    finally { if (active === controller) active = null; }
  }
  function pause() {
    window.clearInterval(timer); window.clearTimeout(first);
    timer = undefined; first = undefined;
    active?.abort(); active = null;
  }
  function resume() {
    if (disposed || pageHidden || document.hidden || timer !== undefined) return;
    first = window.setTimeout(() => void run(), initial ? initialDelay : 0);
    timer = window.setInterval(() => void run(), INBOX_REFRESH_MS);
  }
  const visibility = () => { if (document.hidden) pause(); else resume(); };
  const hide = () => { pageHidden = true; pause(); };
  const show = () => { pageHidden = false; resume(); };
  document.addEventListener("visibilitychange", visibility);
  window.addEventListener("pagehide", hide);
  window.addEventListener("pageshow", show);
  resume();
  return () => {
    disposed = true; pause();
    document.removeEventListener("visibilitychange", visibility);
    window.removeEventListener("pagehide", hide);
    window.removeEventListener("pageshow", show);
  };
}
